import { ca } from '@cian/analytics';
import { TStatusFiltersID, TRoomsFiltersID } from '../../../../store/offerHistory';

export function trackOfferFilterSelect(offerId: number, selectedFilter: TStatusFiltersID | TRoomsFiltersID) {
  ca('eventSite', {
    action: 'select_history_block',
    category: 'card',
    label: selectedFilter,
    name: 'oldevent',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}

export function trackShowMoreClick(offerId: number) {
  ca('eventSite', {
    action: 'click_history_block',
    category: 'card',
    label: 'show_more',
    name: 'oldevent',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}

export function trackOfferClick(offerId: number, clickedOfferId: number) {
  ca('eventSite', {
    action: 'goto_history_block',
    category: 'card',
    label: clickedOfferId,
    name: 'oldevent',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}

export function trackIntoView(offerId: number) {
  ca('eventSite', {
    action: 'show',
    category: 'card',
    label: 'history_block',
    name: 'oldevent',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}
